import React, { useState } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import "./StudentRegister.css";

function StudentRegister() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    dob: "",
    college: "",
    username: "",
    password: "",
  });

  const [errors, setErrors] = useState({});

  const regex = {
    name: /^[A-Za-z\s]{2,30}$/,
    email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    phone: /^[6-9]\d{9}$/,
    username: /^[a-zA-Z0-9_]{4,16}$/,
    password: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,}$/,
  };

  const validate = () => {
    const newErrors = {};
    if (!regex.name.test(formData.firstName))
      newErrors.firstName = "Enter a valid first name.";
    if (!regex.name.test(formData.lastName))
      newErrors.lastName = "Enter a valid last name.";
    if (!regex.email.test(formData.email))
      newErrors.email = "Enter a valid email.";
    if (!regex.phone.test(formData.phone))
      newErrors.phone = "Enter a valid phone number.";
    if (!formData.dob) newErrors.dob = "Date of Birth is required.";
    if (!formData.college.trim())
      newErrors.college = "College name is required.";
    if (!regex.username.test(formData.username))
      newErrors.username = "Username must be 4–16 chars.";
    if (!regex.password.test(formData.password))
      newErrors.password =
        "Password must be 6+ chars with letters & numbers.";
    return newErrors;
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    const newErrors = validate();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    try {
      const res = await axios.post(
        `https://devskillz-ifm6.onrender.com/api/student/register`, // Ensure backend route matches
        formData,
        { withCredentials: true }
      );

      if (res.data.userId) {
        alert("✅ Registration successful! Please verify your email.");
        navigate(`/verify-otp/${res.data.userId}`);
      }
    } catch (err) {
      console.error("Registration error:", err.response?.data || err.message);
      alert(err.response?.data?.error || "❌ Server error. Please try again.");
    }
  };

  return (
    <div className="register-page">
      <div className="register-box">
        <h2>Create Your Account</h2>
        <p className="subtitle">Join us and start your learning journey 🚀</p>

        <form onSubmit={handleRegister} className="register-form">
          <div className="form-grid">
            <div>
              <input
                type="text"
                name="firstName"
                placeholder="First Name"
                value={formData.firstName}
                onChange={handleChange}
                required
                autoComplete="given-name"
              />
              {errors.firstName && <p className="error">{errors.firstName}</p>}
            </div>
            <div>
              <input
                type="text"
                name="lastName"
                placeholder="Last Name"
                value={formData.lastName}
                onChange={handleChange}
                required
                autoComplete="family-name"
              />
              {errors.lastName && <p className="error">{errors.lastName}</p>}
            </div>

            <div>
              <input
                type="email"
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
                required
                autoComplete="email"
              />
              {errors.email && <p className="error">{errors.email}</p>}
            </div>
            <div>
              <input
                type="tel"
                name="phone"
                placeholder="Phone"
                value={formData.phone}
                onChange={handleChange}
                required
                autoComplete="tel"
              />
              {errors.phone && <p className="error">{errors.phone}</p>}
            </div>

            <div>
              <input
                type="date"
                name="dob"
                value={formData.dob}
                onChange={handleChange}
                required
                autoComplete="bday"
              />
              {errors.dob && <p className="error">{errors.dob}</p>}
            </div>
            <div>
              <input
                type="text"
                name="college"
                placeholder="College Name"
                value={formData.college}
                onChange={handleChange}
                required
                autoComplete="organization"
              />
              {errors.college && <p className="error">{errors.college}</p>}
            </div>

            <div>
              <input
                type="text"
                name="username"
                placeholder="Username"
                value={formData.username}
                onChange={handleChange}
                required
                autoComplete="username"
              />
              {errors.username && <p className="error">{errors.username}</p>}
            </div>
            <div>
              <input
                type="password"
                name="password"
                placeholder="Password"
                value={formData.password}
                onChange={handleChange}
                required
                autoComplete="new-password"
              />
              {errors.password && <p className="error">{errors.password}</p>}
              <Link to="/forgot-password" className="forgot-link">
                Forgot Password?
              </Link>
            </div>
          </div>

          <button type="submit" className="submit-btn">
            Register
          </button>
        </form>

        <p className="login-link">
          Already have an account? <Link to="/StudentLogin">Login</Link>
        </p>
      </div>
    </div>
  );
}

export default StudentRegister;
